import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import SubscriptionPlans from "../components/SubscriptionPlans";
import gear_icon from "../assets/icons/gear_icon.png";
import cross_arrows from "../assets/icons/cross_arrows.png";
import { Link } from "react-router-dom";

const Refund = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <Link to="/subscriptions-models/track-refund">
        <div className="w-[95%] border-2 rounded-lg mt-12 ml-4 p-2 cursor-pointer">
          <div className="flex items-center">
            <img src={gear_icon} alt="setting" className="w-6 object-contain" />
            <p className="text-[18px] ml-2">Track Refund Status</p>
          </div>
          <div className="flex items-center">
            <img
              src={cross_arrows}
              alt="setting"
              className="w-5 object-contain ml-1 mt-2"
            />
            <p className="text-[14px] text-[#828282] ml-2 italic">
              See the status of your refund request.
            </p>
          </div>
        </div>
      </Link>

      <div>
        <SubscriptionPlans />
      </div>
    </div>
  );
};

export default Refund;
